var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html } from 'lit';
import { property } from 'lit/decorators.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { BlocksElement } from '../../BlocksElement';
import styles from '../icon.styles';
/**
 * EllipsisCircle component
 * @csspart base- The component's base wrapper
 */
export class BlocksIconEllipsisCircle extends BlocksElement {
    static { this.styles = styles; }
    connectedCallback() {
        super.connectedCallback();
        this.classList.add('cat-icon');
    }
    render() {
        const componentClassName = this.componentClassNames('cat-c-icon', {
            'cat-c-icon--sm': this.size === 'sm',
            'cat-c-icon--lg': this.size === 'lg',
            'cat-c-icon--xl': this.size === 'xl',
            'cat-c-icon--content-strong': this.color === 'content-strong',
            'cat-c-icon--knockout': this.color === 'knockout',
            'cat-c-icon--knockout-brand': this.color === 'knockout-brand',
            'cat-c-icon--information': this.color === 'information',
            'cat-c-icon--success': this.color === 'success',
            'cat-c-icon--warning': this.color === 'warning',
            'cat-c-icon--error': this.color === 'error'
        });
        return html `
      <span part="base" class="${componentClassName}" role="presentation">
        <svg
          aria-hidden="${!this.iconTitle}"
          aria-label="${ifDefined(this.iconTitle)}"
          role="${this.iconTitle && 'img'}"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M12 23C14.9174 23 17.7153 21.8411 19.7782 19.7782C21.8411 17.7153 23 14.9174 23 12C23 9.08262 21.8411 6.28473 19.7782 4.22183C17.7153 2.15893 14.9174 1 12 1C9.08262 1 6.28473 2.15893 4.22183 4.22183C2.15893 6.28473 1 9.08262 1 12C1 14.9174 2.15893 17.7153 4.22183 19.7782C6.28473 21.8411 9.08262 23 12 23ZM7.28571 13.5714C7.70248 13.5714 8.10218 13.4059 8.39688 13.1112C8.69158 12.8165 8.85714 12.4168 8.85714 12C8.85714 11.5832 8.69158 11.1835 8.39688 10.8888C8.10218 10.5941 7.70248 10.4286 7.28571 10.4286C6.86895 10.4286 6.46925 10.5941 6.17455 10.8888C5.87985 11.1835 5.71429 11.5832 5.71429 12C5.71429 12.4168 5.87985 12.8165 6.17455 13.1112C6.46925 13.4059 6.86895 13.5714 7.28571 13.5714ZM13.5714 12C13.5714 12.4168 13.4059 12.8165 13.1112 13.1112C12.8165 13.4059 12.4168 13.5714 12 13.5714C11.5832 13.5714 11.1835 13.4059 10.8888 13.1112C10.5941 12.8165 10.4286 12.4168 10.4286 12C10.4286 11.5832 10.5941 11.1835 10.8888 10.8888C11.1835 10.5941 11.5832 10.4286 12 10.4286C12.4168 10.4286 12.8165 10.5941 13.1112 10.8888C13.4059 11.1835 13.5714 11.5832 13.5714 12ZM16.7143 13.5714C17.1311 13.5714 17.5308 13.4059 17.8255 13.1112C18.1202 12.8165 18.2857 12.4168 18.2857 12C18.2857 11.5832 18.1202 11.1835 17.8255 10.8888C17.5308 10.5941 17.1311 10.4286 16.7143 10.4286C16.2975 10.4286 15.8978 10.5941 15.6031 10.8888C15.3084 11.1835 15.1429 11.5832 15.1429 12C15.1429 12.4168 15.3084 12.8165 15.6031 13.1112C15.8978 13.4059 16.2975 13.5714 16.7143 13.5714Z"
          />
        </svg>
      </span>
    `;
    }
}
__decorate([
    property({ type: String })
], BlocksIconEllipsisCircle.prototype, "color", void 0);
__decorate([
    property({ type: String })
], BlocksIconEllipsisCircle.prototype, "iconTitle", void 0);
__decorate([
    property({ type: String })
], BlocksIconEllipsisCircle.prototype, "size", void 0);
if (customElements.get('cat-icon-ellipsis-circle') === undefined) {
    customElements.define('cat-icon-ellipsis-circle', BlocksIconEllipsisCircle);
}
